import { appSyncApolloClient } from '../helpers/api';
import gql from 'graphql-tag';

export async function getPatches(orgId, userId) {
  if (!orgId) return null;
  if (!userId) return null;
  const resp = await appSyncApolloClient.query({
    fetchPolicy: 'no-cache',
    variables: {
      orgId,
      userId,
    },
    query: gql`
      query getValidPatches($orgId: String!, $userId: String!) {
        getValidPatches(orgId: $orgId, userId: $userId) {
          name
          patchId
          orgLocations {
            locationId
          }
        }
      }
    `,
  });
  const patchesFromAPi = resp?.data?.getValidPatches;
  const sanatizedPatches = patchesFromAPi?.map(p => ({
    name: p.name,
    locations: p.orgLocations?.map(obj => obj?.locationId).filter(x => x),
  }));
  return sanatizedPatches.filter(x => x.locations?.length);
}